import { style } from '@vanilla-extract/css';

export const container = style({
  paddingLeft: 'var(--wt-padding)',
  paddingRight: 'var(--wt-padding)',
  paddingTop: 'var(--wt-image-padding-top)',
  paddingBottom: 'var(--wt-image-padding-bottom)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: 'var(--wt-image-padding-top)',
});

export const image = style({
  width: 'var(--image-width)',
});

export const imageLinkWrapper = style({
  textDecoration: 'none',
  width: 'var(--image-width)',
  margin: 'var(--image-alignment-margins)',
});

export const sponsorText = style({
  color: 'var(--site-theme-text-on-background-color, #000000) !important',
  display: 'block',
  width: '300px',
  margin: 'var(--image-alignment-margins)',
});
